import * as yup from 'yup';

export const ScorecardVerificationValidationSchema = yup.object().shape({
	additionalUsers: yup.array().of(
		yup
			.string()
			.required()
			.test('check-email', '${value} is not a valid email address', (value) => {
				return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$/i.test(value!);
			})
	),
    systemUsers: yup
    .array()
    .of(yup.string().required())
    .min(1, 'Users to notify is required'),
    includeDocuments: yup.boolean()
});